import GroupFilterDto from "../datasourcemodule/GroupFilterDto";
import DataTableReadDto from "./DataTableReadDto";
import DataTableIterationLinkDto from "./DataTableIterationLinkDto";

class DataTableParametersDto {

    Filter: GroupFilterDto | null = null;
    Iteration: DataTableReadDto | null = null;
    // Liens colonne d'itération -> paramètre du filtre. Toujours un tableau (jamais null).
    IterationLinks: DataTableIterationLinkDto[] = [];

}

export default DataTableParametersDto;
